export default __webpack_public_path__ + "static/media/forbidden-product.20132964.svg";